module.exports = __webpack_public_path__ + "img/section5-3.37e0657f.svg";